import API from '@/models/API';

export default class Company {
  constructor(item = {}) {
    this.billing_details = item.billing_details || {};
    this.company = item.company || {};
    this.flags = item.flags || {
      app_settings: {},
      general: {},
      reward: {},
    };
    this.notify_customers = item.notify_customers || {};
    this.category = item.category || {};
    this.country = item.country || {};
    this.order_settings = item.order_settings || {};
    this.timetable = [];
    this.statistics = item.statistics || {
      total_income: 0,
      views: {},
      last_twelve_hours_payments: [],
      last_week_payments: [],
    };
    this.active_subscription = item.active_subscription || null;
    this.unpaid_billing = item.unpaid_billing || false;
    this.loyalty_program_id = item.loyalty_program_id || null;
  }

  static get = () => API.get(`/companies/${localStorage.getItem('storeId')}`);

  static getStatistics = () =>
    API.get(`/companies/${localStorage.getItem('storeId')}/quick-statistics`);

  static getHomePageData = () => API.get(`/companies/${localStorage.getItem('storeId')}/home`);

  static changePaymentStatus = (body) => API.post(`/wbh/stripe/payment-intent`, body);

  static getStores = (query) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/stores${query}`);

  static getStore = (id) => API.get(`/companies/${localStorage.getItem('storeId')}/stores/${id}`);

  static getAllStores = (query) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/all-stores${query}`);

  static deleteCompany = () => API.delete(`/companies/${localStorage.getItem('storeId')}`);

  static getLoyalties = (query) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/loyalties/sub-loyalties${query}`);

  static getNotifications = (payload) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/notifications${payload.query}`);

  static topUp = (body) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/store-credits/top-up`, body);

  static getAutoTopUp = () =>
    API.get(`/companies/${localStorage.getItem('storeId')}/store-credits/threshold`);

  static setAutoTopUp = (body) =>
    API.patch(`/companies/${localStorage.getItem('storeId')}/store-credits/threshold`, body);

  static deleteAutoTopUp = () =>
    API.delete(`/companies/${localStorage.getItem('storeId')}/store-credits/threshold`);
}
